// extracted by mini-css-extract-plugin
export default {"main":"Container_main__W6XjF"};